import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarDays, Clock, Users, MapPin } from "lucide-react";
import { services as mockServices } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const icons = { Sunday: CalendarDays, Wednesday: Users };

export default function ServiceTimes() {
  const [services, setServices] = useState(mockServices);
  useEffect(() => {
    axios.get(`${API}/service-times`).then(r => { if (r.data?.length) setServices(r.data); }).catch(() => {});
  }, []);

  const scrollToVisit = () => {
    const el = document.getElementById("visit");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="relative bg-white py-24 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="text-[#c8a36a] uppercase tracking-[0.32em] text-xs font-bold mb-3">Join Us in Worship</div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0a2d38] tracking-tight">Service Times</h2>
          <div className="mt-6 h-px w-24 bg-[#c8a36a] mx-auto" />
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {services.map((s, i) => {
            const Icon = icons[s.day] || Clock;
            return (
              <button
                key={s.id || i}
                type="button"
                onClick={scrollToVisit}
                className="group relative text-left rounded-2xl bg-[#f5f7f9] hover:bg-white border border-[#e8ecef] hover:border-[#c8a36a] p-8 transition-all"
              >
                <div className="absolute top-6 right-6 h-11 w-11 rounded-full bg-white border border-[#e8ecef] flex items-center justify-center group-hover:bg-[#c8a36a] group-hover:border-[#c8a36a] transition-colors">
                  <Icon className="h-5 w-5 text-[#0a2d38] group-hover:text-white" />
                </div>
                <div className="text-[#c8a36a] uppercase text-xs tracking-[0.28em] font-bold mb-3">{s.day}</div>
                <div className="text-lg text-[#4a5b62] mb-2">{s.name}</div>
                <div className="text-3xl md:text-4xl font-bold text-[#0a2d38] tracking-tight">{s.time}</div>
                {s.note && <div className="mt-3 text-sm text-[#4a5b62] italic">{s.note}</div>}
              </button>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row justify-center items-center gap-4 text-center">
          <a href="#visit" className="btn-gold rounded-full px-7 py-3 inline-flex items-center gap-2">
            <MapPin className="h-4 w-4" /> Plan Your First Visit
          </a>
        </div>
      </div>
    </section>
  );
}
